import * as React from "react";
import Box from "@mui/material/Box";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { TreeView } from "@mui/x-tree-view/TreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import { useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";

// JSON data
// const treeData = [
//   {
//     id: 342341,
//     label: "Surya(QA) Project Manager",
//     children: [
//       {
//         id: 234321,
//         label: "Neela krishnan (Scrum Master)",
//         children: [
//           { id: 2341, label: "Keerthana" },
//           { id: 23422, label: "Mugesh" },
//           {
//             id: 2334543,
//             label: "kabilan",
//             children: [
//               { id: 1234234, label: "lalitha" },
//               { id: 2342342, label: "Ch. Venkatesh" }
//             ]
//           },
//           { id: 234234, label: "Karthikeyan" },
//           { id: 623423, label: "Mahendran" },
//           { id: 723423, label: "Shyam (SD)" },
//           { id: 2342348, label: "Parkavi", children: [{ id: 6786786, label: "Nithish" }] }
//         ]
//       },
//       {
//         id: 678678,
//         label: "Ram (Scrum Master)",
//         children: [
//           {
//             id: 8678,
//             label: "Sathish (SD)",
//             children: [{ id: 8456456, label: "Manikandan" }]
//           },
//           { id: 67867851, label: "Radhika (SD)" },
//           { id: 4564565, label: "Jaya Kavitha(SD)" },
//           { id: 34455677, label: "Shyam (SD)" },
//           { id: 64564568, label: "Parkavi", children: [{ id: 45661, label: "Nithish" }] }
//         ]
//       }
//     ]
//   }
// ];

// Recursive function to render TreeItems
const renderTree = (nodes) => (
  <TreeItem key={nodes.id} nodeId={nodes.id.toString()} label={nodes.label}>
    {Array.isArray(nodes.children)
      ? nodes.children.map((node) => renderTree(node))
      : null}
  </TreeItem>
);

export default function MultiSelectTreeView({loading,data}) {
  return (

        <TreeView
          aria-label="multi-select"
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          multiSelect
        >
          {data.map((node) => renderTree(node))}
        </TreeView>
      
   
  );
}
